<div class="modal in hs-composition-share-dialog" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">
          <span>{{ data.title }}</span>
        </h4>
        <button type="button" (click)="close()" class="btn-close" data-dismiss="modal">
          <span aria-hidden="true">&times;</span><span class="visually-hidden">{{ "COMMON.close" | translateHs: {app: 'default'} }}</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 600px; overflow-y: auto">
        <div class="row mb-2">
          <div class="lead text-secondary">{{data.desc}}</div>
        </div>
        <div class="row mb-2">
          <div class="col-md-3">
            <b>{{ "METADATA.coverage" | translateHs: {app: 'default'} }}</b>
          </div>
          <div class="col-md-9">{{data.coverage ?? "unknown"}}</div>
        </div>
        <div class="row mb-2">
          <div class="col-md-3">
            <b>{{ "METADATA.LoD" | translateHs: {app: 'default'} }}</b>
          </div>
          <div class="col-md-9">{{data.lod ?? "unknown"}}</div>
        </div>
        <div class="row mb-2">
          <div class="col-md-3">
            <b>{{ "METADATA.update" | translateHs: {app: 'default'} }}</b>
          </div>
          <div class="col-md-9">{{data.update ?? "unknown"}}</div>
        </div>
        <div class="row mb-2">
          <div class="col-md-3">
            <b>{{ "METADATA.source" | translateHs: {app: 'default'} }}</b>
          </div>
          <div class="col-md-9">{{data.source ?? "unknown"}}</div>
        </div>
        <div class="row mb-2" *ngIf="data.link">
          <div class="col-md-3">
            <b>{{ "COMMON.url" | translateHs: {app: 'default'} }}</b>
          </div>
          <div class="col-md-9"><a [href]="data.link" target="_blank">{{data.link}}</a></div>
        </div>
      </div>
      <!--div class="modal-footer">
        <div class="btn-group" role="group">
          <button class="btn btn-secondary" (click)="shareOnSocial()">
            <i class="icon-share-alt"></i> {{'COMMON.share' | translateHs: {app: 'default'} }}
          </button>
        </div>
        <button type="button" class="btn btn-secondary" (click)="close()"
          data-dismiss="modal">{{'COMMON.close' | translateHs: {app: 'default'} }}</button>
      </div-->
    </div>
  </div>
</div>
